var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import { decl } from '@yandex-lego/i-bem-react';

var sidePosition = {
    'bottom-left': function bottomLeft(width, height) {
        return { left: -Math.floor(width / 3), bottom: -Math.floor(height / 3) };
    },
    'bottom-right': function bottomRight(width, height) {
        return { right: -Math.floor(width / 3), bottom: -Math.floor(height / 3) };
    },
    'top-left': function topLeft(width, height) {
        return { left: -Math.floor(width / 3), top: -Math.floor(height / 3) };
    },
    'top-right': function topRight(width, height) {
        return { right: -Math.floor(width / 3), top: -Math.floor(height / 3) };
    }
};

export default decl({
    block: 'message-box',
    elem: 'corner',
    mods: function mods(_ref) {
        var side = _ref.side;

        return { side: side };
    },
    attrs: function attrs(_ref2) {
        var side = _ref2.side,
            width = _ref2.width,
            height = _ref2.height;

        if (!height) {
            height = width;
        }

        var style = _extends({
            width: width,
            height: height
        }, sidePosition[side](width, height));

        return { style: style };
    },
    content: function content(_ref3) {
        var children = _ref3.children,
            img = _ref3.img;

        return img || children;
    }
});